module.exports = __webpack_public_path__ + "media/images/drop-icon-f6b65c8152ac12fca91686d57f962ec0cd16cb3e4e8f1b1ca0390d3ecaacd421.svg";